import React, { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, MenuItem, Select, FormControl, InputLabel
} from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const START_YEAR = 2025; // Change to your first year of data if needed
const currentYear = new Date().getFullYear();

export default function StandingsPage() {
  const auth = useAuth();
  const token = auth.user?.access_token || auth.user?.id_token;
  const [standings, setStandings] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [year, setYear] = useState(currentYear);

  useEffect(() => {
    setLoading(true);
    if (!token) return;
    fetch(`https://elk87mfiog.execute-api.us-east-1.amazonaws.com/standings?year=${year}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    })
      .then(res => res.json())
      .then(data => setStandings(data))
      .catch(err => setError("Failed to load standings"))
      .finally(() => setLoading(false));
  }, [token, year]);

  const handleYearChange = (event) => {
    setYear(Number(event.target.value));
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 8 }}>
        <CircularProgress size={60} />
      </Box>
    );
  }

  return (
    <>
      <img src="/logo192.png" alt="Logo192" width={100} height={100} style={{ display: "block", margin: "0 auto" }} />
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <FormControl sx={{ minWidth: 120 }}>
          <InputLabel id="year-select-label">Year</InputLabel>
          <Select
            labelId="year-select-label"
            id="year-select"
            value={year}
            label="Year"
            onChange={handleYearChange}
          >
            {Array.from({ length: currentYear - START_YEAR + 1 }, (_, i) => {
              const y = currentYear - i;
              return (
                <MenuItem key={y} value={y}>
                  {y}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Box>
      <TableContainer
        component={Paper}
        sx={{ mt: 4, maxWidth: 500, mx: "auto", borderRadius: 3, boxShadow: 3 }}
      >
        <Typography variant="h5" align="center" sx={{ mt: 2, mb: 2 }}>
          Who Will be the Big Birdie Bitch?
        </Typography>
        {error && <Typography color="error">{error}</Typography>}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Rank</TableCell>
              <TableCell>User</TableCell>
              <TableCell align="right">Birdies</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {standings.map((row, idx) => (
              <TableRow
                key={row.user_id}
                sx={{
                  backgroundColor: idx === 0 ? "gold.100" : idx % 2 === 0 ? "grey.100" : "white",
                  fontWeight: idx === 0 ? 700 : 400,
                }}
              >
                <TableCell>
                  {idx === 0 ? <EmojiEventsIcon color="warning" sx={{ verticalAlign: "middle" }} /> : idx + 1}
                </TableCell>
                <TableCell>{row.user_id}</TableCell>
                <TableCell align="right">{row.count}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}